var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeftBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 6H3.135L6.768 1.64C7.122 1.216 7.064 0.585001 6.64 0.232001C6.215 -0.121999 5.585 -0.0639994 5.232 0.360001L0.232 6.36C0.193 6.407 0.173 6.462 0.144 6.514C0.12 6.556 0.091 6.592 0.073 6.638C0.028 6.753 0.001 6.874 0.001 6.996C0.001 6.997 0 6.999 0 7C0 7.001 0.001 7.003 0.001 7.004C0.001 7.126 0.028 7.247 0.073 7.362C0.091 7.408 0.12 7.444 0.144 7.486C0.173 7.538 0.193 7.593 0.232 7.64L5.232 13.64C5.43 13.877 5.714 14 6 14C6.226 14 6.453 13.924 6.64 13.768C7.064 13.415 7.122 12.784 6.768 12.36L3.135 8H15C15.552 8 16 7.552 16 7C16 6.448 15.552 6 15 6",
    fill: "#151A30"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBlack);
export default __webpack_public_path__ + "static/media/arrow-left-black.c7fe68d31731075cdd766ab2b4e7e021.svg";
export { ForwardRef as ReactComponent };